import { forwardRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AlertMessage from '~/components/data-display/AlertMessage';
import { SkeletonLoader } from '~/components/data-display/SkeletonLoader/SkeletonLoader';
import { useRenderDocumentInsideNode } from '~/utils/xml-parser';

interface AssosoftwarePreviewContentProps {
  xmlDocument: Document;
  className?: string;
}

const LoadingPreview = ({ width, height }: { width?: number; height?: number }) => {
  return <SkeletonLoader width={width || 100} height={height || 500} style={{ borderRadius: 10 }} />;
};

const XmlPreview = ({ xmlDocument, width }: { xmlDocument: Document; width?: number }) => {
  const { t } = useTranslation();
  const state = useRenderDocumentInsideNode(xmlDocument);

  switch (state.state) {
    case 'pending':
      return <LoadingPreview width={width} />;
    case 'success':
      return <div dangerouslySetInnerHTML={{ __html: state.html.innerHTML }} />;
    case 'error':
      return <AlertMessage type="warning">{t(state.error)}</AlertMessage>;
  }
};

const AssosoftwarePreviewContent = forwardRef<HTMLDivElement, AssosoftwarePreviewContentProps>(
  ({ xmlDocument, className }, ref) => {
    const [myRef, setMyRef] = useState<HTMLDivElement | null>(null);
    const [width, setWidth] = useState<number | undefined>(undefined);

    useEffect(() => {
      setWidth(myRef ? myRef.getBoundingClientRect().width - 50 : undefined);
    }, [myRef]);

    return (
      <div
        style={{ display: 'flex', justifyContent: 'center' }}
        className={className}
        ref={(node) => {
          setMyRef(node);
          if (typeof ref === 'function') {
            ref(node);
          } else if (ref) {
            ref.current = node;
          }
        }}
      >
        <XmlPreview xmlDocument={xmlDocument} width={width} />
      </div>
    );
  },
);

export default AssosoftwarePreviewContent;
